export default __webpack_public_path__ + "static/media/trr-food-smallplate-fries.ab9d7f90.png";